/**
 * 性別の列挙クラス
 * @param code : コード
 * @param name : 名称
 */
const _sex = {
  "0": "不明", 
  "1": "男性",
  "2": "女性",
}

export default {
  data() {
    return {
      sex: _sex,
    }
  }
}

